import React from "react";
import * as styles from "./EndOfLifeWarning.css";

export const EndOfLifeWarning: React.FC = () => {
  return (
    <div className={styles.banner}>
      <p className={styles.text}>
        CoScreen will reach end of life on July 31, 2026
      </p>
    </div>
  );
};
